// 导出页面为PDF格式
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";

export default {
  install(Vue, options) {
    /**
     * 
     * @param {*} reportName 下载时候的标题
     * @param {*} isDownload  是否下载默认为下载，传false不下载
     */
    Vue.prototype.getPdf = function (reportName, isDownload = true) {
      //     var target = document.getElementsByClassName("right-aside")[0];
      // target.style.background = "#FFFFFF";
      return new Promise((resolve, reject) => {
        var title = reportName;
        html2Canvas(document.querySelector('#pdfDom'), {
          allowTaint: true
        }).then((canvas) => {
          let contentWidth = canvas.width
          let contentHeight = canvas.height
          //一页pdf显示html页面生成的canvas高度;
          let pageHeight = contentWidth / 592.28 * 841.89
          //未生成pdf的html页面高度
          let leftHeight = contentHeight
          //页面偏移
          let position = 0
          //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
          let imgWidth = 595.28
          let imgHeight = 592.28 / contentWidth * contentHeight
          let pageData = canvas.toDataURL('image/jpeg', 1.0)
          let PDF = new JsPDF('', 'pt', 'a4')
          //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
          //当内容未超过pdf一页显示的范围，无需分页
          if (leftHeight < pageHeight) {
            PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
          } else {
            while (leftHeight > 0) {
              PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
              leftHeight -= pageHeight
              position -= 841.89
              //避免添加空白页
              if (leftHeight > 0) {
                PDF.addPage()
              }
            }
          }
          if (isDownload) {
            PDF.save(title + '.pdf')
          }
          // 删除本地存储的base64字段
          const pdfData = PDF.output('datauristring')//获取base64Pdf
          resolve(pdfData)
        }
        )
      })
    }
  }
}
// export default {
//   install(Vue, options) {
//     Vue.prototype.getPdf = function (id, title) {
//       const loading = Vue.prototype.$loading({
//         fullscreen: true,
//         lock: true,
//         text: 'Loading',
//         spinner: 'el-icon-loading',
//         background: 'rgba(0, 0, 0, 0.7)'
//       });
//       let shareContent = document.getElementById(id), //需要截图的包裹的（原⽣的）DOM 对象
//         width = shareContent.scrollWidth, //获取dom 宽度
//         height = shareContent.scrollHeight, //获取dom ⾼度
//         canvas = document.createElement("canvas"), //创建⼀个canvas节点
//         scale = 1; //定义任意放⼤倍数⽀持⼩数
//       canvas.width = width * scale; //定义canvas 宽度 * 缩放
//       canvas.height = height * scale; //定义canvas⾼度 *缩放
//       canvas.style.width = shareContent.clientWidth * scale + "px";
//       canvas.style.height = shareContent.clientHeight * scale + "px";
//       canvas.getContext("2d").scale(scale, scale); //获取context,设置scale
//       let opts = {
//         scale: scale, // 添加的scale 参数
//         canvas: canvas, //⾃定义 canvas
//         logging: false, //⽇志开关，便于查看html2canvas的内部执⾏流程
//         width: width, //dom 原始宽度
//         height: height,
//         y:window.pageYOffset,
//         // useCORS: true, // 【重要】开启跨域配置
//         windowHeight: shareContent.scrollHeight * 2, // 获取y方向滚动条中的内容
//       }
//       html2Canvas(shareContent, opts).then(() => {
//         var contentWidth = canvas.width;
//         var contentHeight = canvas.height;
//         //⼀页pdf显⽰html页⾯⽣成的canvas⾼度;
//         var pageHeight = (contentWidth / 592.28) * 841.89;
//         //未⽣成pdf的html页⾯⾼度
//         var leftHeight = contentHeight;
//         //页⾯偏移
//         var position = 0;
//         //a4纸的尺⼨[595.28,841.89]，html页⾯⽣成的canvas在pdf中图⽚的宽⾼
//         var imgWidth = 595.28;
//         var imgHeight = (592.28 / contentWidth) * contentHeight;
//         var pageData = canvas.toDataURL("image/jpeg", 1.0);
//         var PDF = new JsPDF("", "pt", "a4");
//         if (leftHeight < pageHeight) {
//           PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
//         console.log(PDF,'4185644');
//         } else {
//           while (leftHeight > 0) {
//             PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
//             leftHeight -= pageHeight;
//             position -= 841.89;
//             if (leftHeight > 0) {
//               PDF.addPage();
//             }
//           }
//         }
//         var pdfData = PDF.output('datauristring')//获取base64Pdf
//         console.log(pdfData,'4185644');
//         return pdfData
//         // // resolve(pdfData)
//         // return
//         // PDF.save(title + ".pdf"); // 这⾥是导出的⽂件名
//         // loading.close();
//       });
//     };
//   }
//  };


 // export default {
//   install(Vue, options) {
//     Vue.prototype.getPdf = function(title) {
//       html2Canvas(document.querySelector("#pdfDom"), {
//         allowTaint: false, // 允许污染 // useCORS:true, // 使用跨域
//         width: window.screen.availWidth, // 显示的canvas窗口宽度
//         height: window.screen.availHeight, // 显示的canvas 窗口高度
//         windowWidth: document.body.scrollWidth, // 获取X方向滚动条的内容
//         windowHeight: document.body.scrollHeight, // 获取y方向滚动条的内容
//         x: 0, //页面在水平方向上没有滚动，故设置为0
//         y: window.pageYOffset // 页面在垂直方向的滚动距离
//       }).then(function(canvas) {
//         let contentWidth = canvas.width;
//         let contentHeight = canvas.height;
//         let pageHeight = (contentWidth / 592.28) * 841.89;
//         let leftHeight = contentHeight;
//         let position = 0;
//         let imgWidth = 595.28;
//         let imgHeight = (592.28 / contentWidth) * contentHeight;
//         let pageData = canvas.toDataURL("image/jpeg", 1.0);
//         let PDF = new JsPDF("", "pt", "a4");
//         if (leftHeight < pageHeight) {
//           PDF.addImage(pageData, "JPEG" || "GIF", 0, 0, imgWidth, imgHeight);
//         } else {
//           while (leftHeight > 0) {
//             PDF.addImage(
//               pageData,
//               "JPEG" || "F",
//               0,
//               position,
//               imgWidth,
//               imgHeight
//             );
//             leftHeight -= pageHeight;
//             position -= 841.89;
//             if (leftHeight > 0) {
//               PDF.addPage();
//             }
//           }
//         }
//         PDF.save(title + ".pdf");
//       });
//     };
//   }
// };